<script setup lang="ts">
  import { VLoader } from "@krainovsd/vue-ui";
  import { onMounted, ref } from "vue";
  import { useUsersStore } from "@/entities/users";
  import { OAUTH_PROVIDER } from "@/api";

  const usersStore = useUsersStore();
  const checked = ref(false);

  onMounted(() => {
    void OAUTH_PROVIDER.register().then(async (ok) => {
      if (!ok) {
        return;
      }
      await usersStore.getCurrentUser();
      void OAUTH_PROVIDER.startRefreshFlow().then(async (token) => {
        if (!token) {
          if (!OAUTH_PROVIDER.expired) {
            return void window.location.replace("/error");
          }
          await OAUTH_PROVIDER.startLoginFlow();
          return;
        }

        checked.value = true;
      });
    });
    if (document.location.pathname === "/error") {
      checked.value = true;
    }
  });
</script>

<template>
  <slot v-if="checked"></slot>
  <div v-else :class="$style.loading">
    <VLoader type="primary" />
  </div>
</template>

<style lang="scss" module>
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 25px;
    height: 25px;
    --ksd-loader-primary-size: 25px;
  }
</style>
